export const ACCOUNT_TYPE_STANDARD = 'standard';
export const ACCOUNT_TYPE_RETIREMENT = 'retirement';
export const ACCOUNT_TYPE_UTMA = 'utma';

export const APPLICATION_TYPE_INDIVIDUAL = 'Individual';
export const APPLICATION_TYPE_IRA = 'IRA';
export const APPLICATION_TYPE_UTMA = 'UTMA';
export const APPLICATION_TYPE_CORPORATE = 'Corporate';
export const APPLICATION_TYPE_JOINT_TENANTS = 'JointTenants';

export const ACCOUNT_TYPE_INDIVIDUAL = 'Individual';

export const ACCOUNT_TYPE_IRA_ROTH = 'Roth';
export const ACCOUNT_TYPE_IRA_TRADITIONAL = 'Traditional';
export const ACCOUNT_TYPE_IRA_SIMPLE = 'SIMPLE';
export const ACCOUNT_TYPE_IRA_SEP = 'SEP';

export const ACCOUNT_TYPE_UTMA_CUSTODIAN = 'Custodian';
export const ACCOUNT_TYPE_UTMA_TRUSTEE = 'Trustee';

export const ACCOUNT_TYPE_CORPORATE_LLC = 'LimitedLiabilityCorporation';
export const ACCOUNT_TYPE_CORPORATE_CORPORATE = 'Corporate';
export const ACCOUNT_TYPE_CORPORATE_SOLE_PROPRIETORSHIP = 'SoleProprietorship';
export const ACCOUNT_TYPE_CORPORATE_PARTNERSHIP = 'Partnership';
export const ACCOUNT_TYPE_CORPORATE_TRUST = 'Trust';
export const ACCOUNT_TYPE_CORPORATE_APP = 'CorporateApplication';

export const ACCOUNT_TYPE_JOINT_TENANTS_COMMON = 'Common';
export const ACCOUNT_TYPE_JOINT_TENANTS_WITH_RIGHT_OF_SURVIVORSHIP =
  'WithRightOfSurvivorship';

export const RETIREMENT_OWNER_ME = 'standard_retirement';
export const RETIREMENT_OWNER_BUSINESS = 'business';

export const RETIREMENT_IRA_TYPE_ROTH = 'roth';
export const RETIREMENT_IRA_TYPE_TRADITIONAL = 'traditional';
export const RETIREMENT_IRA_TYPE_SIMPLE = 'simple';
export const RETIREMENT_IRA_TYPE_SEP = 'sep';

export const STANDARD_OWNER_ME = 'standard_personal';
export const STANDARD_OWNER_JOINT = 'joint';
export const STANDARD_OWNER_TRUST = 'trust';
export const STANDARD_OWNER_BUSINESS = 'business';

export const BUSINESS_TYPE_LLC = 'llc';
export const BUSINESS_TYPE_CORP = 'corp';
export const BUSINESS_TYPE_PARTNERSHIP = 'partnership';
export const BUSINESS_TYPE_SOLE = 'sole';

export const UTMA_TYPE = 'utma';
export const UTMA_OWNER_CUSTODIAN = 'custodian';
export const UTMA_OWNER_TRUST = 'trustee';
